import * as React from 'react';
//import { GroupedList, GroupHeader, IGroup, IGroupHeaderProps, SelectionMode } from '@fluentui/react';

const VisibilitaGroupedList: React.FunctionComponent<{ lines: string[] }> = ({ lines }) => {
    //const groups: IGroup[] = [{
    //    key: 'visibilita',
    //    name: 'Aggiornata la visibilità del protocollo',
    //    startIndex: 0,
    //    count: lines.length,
    //    level: 0,
    //    isCollapsed: true,
    //}];

    //const onRenderHeader = (props?: IGroupHeaderProps): JSX.Element => (
    //    <GroupHeader {...props} styles={{ title: { paddingLeft: -10, fontSize: 12, fontWeight: 'normal' } }} />
    //);

    //const onRenderCell = (_depth?: number, item?: string): JSX.Element => (
    //    <div style={{ paddingLeft: 0, fontSize: 12 }}>{item}</div>
    //);

    return (
        //<GroupedList
        //    items={lines}
        //    onRenderCell={onRenderCell}
        //    selectionMode={SelectionMode.none}
        //    groups={groups}
        //    groupProps={{ onRenderHeader }}
        //    compact
        ///>

        <React.Fragment>
            {lines.map((el, index) => (
                <div key={index}>{el}</div>
            ))}
        </React.Fragment>
    );
};

export default VisibilitaGroupedList;
